import Select from 'react-select';

export const SearchDropdownSelect = ({ id, title, onSelect, data }) => {

    let byReactSelectModel = data.map(it => ({ value: it.id, label: it.name }));

    return (
        <div className={'dropdown-searchable-selection-block'}>
            {title !== null ? (<div>{title}</div>) : (<></>)}
            <Select
                className='basic-single'
                classNamePrefix='react-search-select'
                isSearchable={true}
                value={byReactSelectModel.filter(it => it.value === id)}
                name='react-search-select'
                options={byReactSelectModel}
                onChange={(e) => onSelect(e.value)}
                placeholder={title}
            />
        </div>
    );
};